import React, { useMemo } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';
import { buildOtpAuthUri } from '../utils/totpQr';

/**
 * QR code for adding a mailbox TOTP secret to an authenticator app.
 */
const TotpQrCode = ({ secret, accountEmail, issuer = 'GillyReach' }) => {
  const uri = useMemo(
    () => buildOtpAuthUri({ secret, accountEmail, issuer }),
    [secret, accountEmail, issuer]
  );
  if (!uri) return null;
  return (
    <Box
      mt={2}
      p={3}
      borderRadius="md"
      bg="rgba(255,255,255,0.04)"
      border="1px solid rgba(255,255,255,0.1)"
      alignSelf="flex-start"
    >
      <Text fontSize="xs" color="rgba(255,255,255,0.55)" mb={2}>
        Scan to add 2FA in Google Authenticator or Microsoft Authenticator
      </Text>
      <Box bg="white" p={2} borderRadius="md" display="inline-block">
        <QRCodeSVG value={uri} size={168} level="M" marginSize={1} />
      </Box>
    </Box>
  );
};

export default TotpQrCode;
